module.exports = __webpack_public_path__ + "img/services-three-3.df918831.jpg";